import Axios from 'axios';

export default Axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  baseURL: 'https://api',
});

export const app = Axios.create({
  baseURL: '/',
});
